/**
 * Converts a date string from "YYYY-MM-DD" to "DD-MM-YYYY" for display purposes.
 * Returns empty string if input is falsy.
 */
export function formatDate(dateStr) {
  if (!dateStr) return "";
  const parts = dateStr.substring(0, 10).split("-");
  if (parts.length !== 3) return dateStr;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}
